module.exports = __webpack_public_path__ + "img/tn-stock-1.9dbde7f5.jpeg";